/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class TimeStateApi extends runtime.BaseAPI {
    /**
     * Time State Read
     */
    async v1TimeStateReadRaw(requestParameters, initOverrides) {
        if (requestParameters['idProfile'] == null) {
            throw new runtime.RequiredError('idProfile', 'Required parameter "idProfile" was null or undefined when calling v1TimeStateRead().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/time-state/{id_profile}`;
        urlPath = urlPath.replace(`{${"id_profile"}}`, encodeURIComponent(String(requestParameters['idProfile'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Time State Read
     */
    async v1TimeStateRead(requestParameters, initOverrides) {
        const response = await this.v1TimeStateReadRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Time State Update
     */
    async v1TimeStateUpdateRaw(requestParameters, initOverrides) {
        if (requestParameters['idProfile'] == null) {
            throw new runtime.RequiredError('idProfile', 'Required parameter "idProfile" was null or undefined when calling v1TimeStateUpdate().');
        }
        if (requestParameters['timeStateUpdate'] == null) {
            throw new runtime.RequiredError('timeStateUpdate', 'Required parameter "timeStateUpdate" was null or undefined when calling v1TimeStateUpdate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/time-state/{id_profile}`;
        urlPath = urlPath.replace(`{${"id_profile"}}`, encodeURIComponent(String(requestParameters['idProfile'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['timeStateUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Time State Update
     */
    async v1TimeStateUpdate(requestParameters, initOverrides) {
        const response = await this.v1TimeStateUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
